'use client';

import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { COMPANY, REGISTRATION_DETAILS } from '@/lib/company';
import { useI18n } from '@/i18n/LocaleProvider';

export default function Footer() {
  const { t } = useI18n();

  return (
    <footer className="border-t border-border mt-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2.5 mb-3">
              <AppLogo size={28} />
              <span className="font-display font-bold text-base tracking-tight text-foreground">TCGSecret</span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              {t.footer.tagline}
            </p>
          </div>

          {/* About */}
          <div>
            <h3 className="text-xs font-bold tracking-widest uppercase text-accent mb-4">{t.footer.about}</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link href="/#about" className="text-muted-foreground hover:text-foreground transition-colors">{t.nav.aboutUs}</Link>
              </li>
              <li>
                <Link href="/#store" className="text-muted-foreground hover:text-foreground transition-colors">{t.footer.storeSoon}</Link>
              </li>
              {REGISTRATION_DETAILS.map(item => (
                <li key={item.label} className="text-muted-foreground">
                  <span className="font-semibold text-foreground">{item.label}:</span> {item.value || '—'}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xs font-bold tracking-widest uppercase text-accent mb-4">{t.footer.contact}</h3>
            <ul className="space-y-2 text-sm">
              <li className="text-muted-foreground">
                <span className="font-semibold text-foreground">{t.footer.email}:</span>{' '}
                <a href={`mailto:${COMPANY.email}`} className="hover:text-foreground transition-colors">{COMPANY.email}</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            © 2026 TCGSecret
          </p>
          <div className="flex items-center gap-6 flex-wrap justify-center">
            <Link href="/" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">{t.nav.home}</Link>
            <Link href="/category" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">{t.nav.categories}</Link>
            <Link href="/preorders" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">{t.nav.preorders}</Link>
            <Link href="/terms" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">{t.footer.terms}</Link>
            <Link href="/privacy-policy" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">{t.footer.privacy}</Link>
            <Link href="/returns" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">{t.footer.returns}</Link>
            <Link href="/shipping" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">{t.footer.shipping}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
